import Link from '@/routing/AppLink';
import Image from 'next/image';

import { Popup } from '@/apis/popup/types';

import { useMediaQuery } from '@/hooks/shared/useMediaQuery';

import getFileInfo from '@/utils/getFileInfo';

import FileInfo from '@/types/fileInfo';
import { FileInfoType } from '@/types/fileInfoType';

import Modal from './modal';
import type { ModalType } from './types';

type Props = {
  id: string;
  size: ModalType['size'];
  closeOnClickOutside: boolean;
  /** size가 full이 아니어도 모바일에서 full 반응형 처리 옵션 */
  data: {
    modal: Popup;
    file_info: FileInfoType;
  };
  isResponsive: boolean;
  modalSubmit: () => void;
  modalClose: () => void;
};

export default function PopupImageModal({
  id,
  size,
  closeOnClickOutside,
  data,
  isResponsive = false,
  modalClose,
  modalSubmit,
}: Props) {
  const isDesktop = useMediaQuery({
    query: '(min-width: 992px)',
  });

  const { modal, file_info } = data;

  const imageInfo = getFileInfo({
    file_info: file_info,
    fileCategory: 'popup_img',
    idx: modal.idx,
  }) as FileInfo;

  const imageurl = imageInfo.file_storage_path;

  // 반응형 코드 추가
  const modalSize = isResponsive ? (isDesktop ? size : 'full') : size;

  return (
    <>
      <Modal.Overlay id={id} closeOnClickOutside={closeOnClickOutside} />
      <Modal size={modalSize} isHeightAuto>
        <ImageWrapper link={modal.link}>
          <Image
            width={Number(imageInfo.file_image_width)}
            height={Number(imageInfo.file_image_height)}
            style={{ objectFit: 'contain', width: '100%', height: '100%' }}
            src={imageurl}
            alt="사진"
            sizes="800px"
          />
        </ImageWrapper>
        <Modal.Footer
          buttonsInfo={[
            { submitButtonText: '하루동안 보지 않기', modalSubmit },
            { closeButtonText: '닫기', modalClose },
          ]}
        />
      </Modal>
    </>
  );
}

/** link 유무에 따라 Link / div 로 갈리지만 스타일은 동일하다 */
const IMG_WRAPPER_CLASS = 'relative flex w-full items-center overflow-hidden';

function ImageWrapper({
  link,
  children,
}: {
  link?: string;
  children: React.ReactNode;
}) {
  return link ? (
    <Link href={link} target="_blank" className={IMG_WRAPPER_CLASS}>
      {children}
    </Link>
  ) : (
    <div className={IMG_WRAPPER_CLASS}>{children}</div>
  );
}
